import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { customTheme } from '@/theme';
import { InvalidPage } from 'assessment/pages/components';

const ConsentPage = lazy(() => import('../pages/ConsentPage'));

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});

export const CandidateConsentRoutes = () => (
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={customTheme}>
      <Switch>
        <Route path="/:orgSlug/consent/:consentId">
          <ConsentPage />
        </Route>
        <Route path="*">
          <InvalidPage />
        </Route>
      </Switch>
    </ChakraProvider>
  </QueryClientProvider>
);
